import resourcesLibrary from "./components/resourcesLibrary";
import { faqs } from "./components/faqs";
import { Select } from "./components/select";
import { Ajax } from "./components/ajax";
import { Search } from "./components/search";
import { Menu } from "./components/menu";
import { Filter } from "./components/filter";
import { CountryFlag } from "./components/countryFlag";
import { Carousel } from "./components/carousel";
import { Countdown } from "./components/countdown";

require("./utilities/flickity.pkgd.min.js");

document.addEventListener("DOMContentLoaded", () => {
	resourcesLibrary();
	new Select();
	new Ajax();
	new faqs();
	new Search();
	new Menu();
	new Filter();
	new CountryFlag();
	new Carousel();
	new Countdown();
});
